import React from "react"
import ErrorIcon from "@material-ui/icons/Error"
import ExpandLessIcon from "@material-ui/icons/ExpandLess"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import CompilationErrorsBox from"../compilation-errors"
/**
 * Input compiler errors component 
 * * @param props{{
 * conpileErrors:array
 * expanded:boolean
 * setExpanded:function
 * scrollToSource:function
 * }} 
 */
export default function CompilerErrors({ compileErrors, expanded, setExpanded, scrollToSource }) {
  return <div
    css={`   
      padding: 10px;
      border: 1px solid red;
      background: white;
      height: ${expanded?"360px":""};
      overflow: auto;
    `}
  ><div
    css={`
      display: flex;
      align-items: center;
      justify-content: center;
      color: red;
    `}
  >
      <ErrorIcon />
   Error
   ({compileErrors.length})
      {expanded ?
        <button onClick={() => setExpanded(false)} style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}>
          <ExpandMoreIcon  />
        </button>
        : <button onClick={() => setExpanded(true)} style={{background: "none", border: "none", padding: 0, cursor: "pointer" }}>
          <ExpandLessIcon  />
        </button>
      }
    </div>
    {expanded && <div
    css={`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
    `}
    >
      <CompilationErrorsBox hideTitle={true} compilationErrors={compileErrors} scrollToSource={scrollToSource} />
    </div>}
  </div>
}